<template>
    <div>
        <vue-simple-spinner class="m-t-30" v-if="loading" message="Carregando..."></vue-simple-spinner>
        <form-location :obj.sync="location" v-if="step == 0 && !loading" @submit="submitLocation"></form-location>
        <form-details :obj.sync="details" v-if="step == 1 && !loading" @submit="submitDetails" @goback="goBack()"></form-details>
        <form-aboutme :obj.sync="about_me" v-if="step == 2 && !loading" @submit="submitAboutMe" @goback="goBack()"></form-aboutme>
        <form-photo v-if="step == 3 && !loading" @submit="submitPhoto" @goback="goBack()"></form-photo>
    </div>
</template>

<script>
import FormLocation from './form-location.vue';
import FormDetails from './form-details.vue';
import FormAboutme from './form-aboutme.vue';
import FormPhoto from './form-photo.vue';

import _ from '../../../../../../legacy/node_modules/lodash';
import Spinner from '../../../../../../legacy/node_modules/vue-simple-spinner';

export default {
    props: ['plocation', 'prent_price', 'start_from', 'load_roommate', 'user'],
    components: { FormLocation, FormDetails, FormAboutme, FormPhoto },
    data() {
        return {
            step: this.start_from,
            form: {},
            loading: true,
            location: {
                fk_district: this.plocation.fk_district,
                fk_city: this.plocation.fk_city,
                fk_state: this.plocation.fk_state,
                lat: this.plocation.lat,
                lng: this.plocation.lng,
                district: this.plocation.district,
                has_address: this.plocation.district ? true : false,
            },
            details: {
                moving_date: '',
                staying_time: '',
                rent_price: this.prent_price,
                description: '',
            },
            about_me: {
                has_kid: false,
                has_pet: false,
                smoker: false,
                has_job: false,
                student: false,
                about_student: '',
                about_job: '',
                retired: false,
                unemployed: false,
                carrying_pets: false,
                accepting_pets: false,
                about_me: ''
            }
        }
    },
    methods: {
        submitLocation(obj) {
            this.location = _.assign(this.location, obj);
            this.step++;
        },
        submitDetails(obj) {
            this.details = _.assign(this.details, obj);
            this.step++;
        },
        submitAboutMe(obj) {
            this.about_me = _.assign(this.about_me, obj);

            let l = Ladda.create( this.$el.querySelector('.ladda-button') );
            l.start();

            let form = {};
            Object.assign(form, this.location, this.details, this.about_me);
            form.active = 1;

            axios.post('/roommate/submit', form).then((res) => {
                l.stop();

                window.dataLayer.push({
                    event: 'new_roommate_ad',
                    event_category: 'conversion',
                    event_label: 'new_roommate_ad_created',
                });

                EventBus.$emit('roommate_ad_created', null, {roommate_ad: res.data.data});

                if (this.user.has_photo == false) {
                    this.step++;
                } else {
                    this.$emit('close');
                    EventBus.$emit('refresh_page');
                }
            }).catch(function (err) {
                l.stop();
                window.App.error('Ocorreu um erro ao salvar seu perfil. Atualize esta página e tente novamente!');
                Sentry.captureException(err);
            });
        },
        getRoommateAd() {
            axios.get('/roommate/get').then((res) => {
                const ad = res.data.data;
                
                if (!ad) {
                    this.loading = false;
                    return;
                }

                this.location = {
                    location: ad.city,
                    fk_district: ad.fk_district,
                    fk_city: ad.fk_city,
                    fk_state: ad.fk_state,
                    lat: ad.lat,
                    lng: ad.lng,
                    address: ad.address,
                    has_address: true,
                };

                this.details = {
                    moving_date: ad.moving_date,
                    staying_time: ad.staying_time,
                    rent_price: ad.rent_price,
                    description: ad.description,
                };

                this.about_me = {
                    has_kid: ad.has_kid,
                    has_pet: ad.has_pet,
                    smoker: ad.smoker,
                    has_job: ad.has_job,
                    student: ad.student,
                    about_me: ad.about_me,
                    about_student: ad.about_student,
                    about_job: ad.about_job,
                    retired: ad.retired,
                    unemployed: ad.unemployed,
                    carrying_pets: ad.carrying_pets,
                    accepting_pets: ad.accepting_pets,
                };

                this.loading = false;
            });
        },
        submitPhoto() {
            this.$emit('close');
            EventBus.$emit('refresh_page');
        },
        goBack() {
            this.step--;
        }
    },
    created() {
        window.scrollTo(0,0);

        if (this.load_roommate) {
            this.getRoommateAd();
        } else {
            this.loading = false;
        }
    },
}
</script>
